import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isEmpty } from "lodash";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import DeleteModal from '../../../components/Common/DeleteModal';
import LangModal from '../../../components/Common/LangModal';

import {
  deleteCatalog as onDeleteCatalog,
  addCatalog as onAddCatalog,
  updateCatalog as onUpdateCatalog,
  getCatalog as onGetCatalog,
} from "store/contacts/actions";

import {
  Name,
  Status
} from "./EcommerceOrderCol";

import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader';
import { compressPdf } from '../../../helpers/compressPdf';

//redux
import { useSelector, useDispatch } from "react-redux";

import "toastr/build/toastr.min.css";

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from "reactstrap";

const IMG_BASE = 'https://buharasubdomain.stechomeyazilim.info/';

function CatalogPage() {

  //meta title
  document.title = "Kataloglar | BUHARA - Admin Paneli";

  const [getIsActive, setIsActive] = useState(false);
  const [getFileNameImage, setFileNameImage] = useState(null);   // kapak görseli
  const [getFileNamePDF, setFileNamePDF] = useState(null);       // pdf dosyası
  const [pdfCompressInfo, setPdfCompressInfo] = useState(null);  // sıkıştırma durumu mesajı

  // Yükleme parametreleri (Slider ile aynı endpoint)
  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://buharaadmin.stechomeyazilim.info:8099/uploadfile', body }
  }

  // PDF yükleme parametreleri — yüklemeden ÖNCE tarayıcıda küçültür.
  // Büyük katalog PDF'leri (yüzlerce MB/GB) sunucuya tam boyutta gönderilince
  // ağ kopması yaşanıyordu; burada ~150 DPI'a indirip sadece küçük dosyayı yolluyoruz.
  const getUploadParamsPDF = async ({ file }) => {
    let toSend = file;
    try {
      const mb = (file.size / 1024 / 1024).toFixed(0);
      if (file.size > 20 * 1024 * 1024) {
        setPdfCompressInfo(`PDF küçültülüyor (${mb} MB)… Lütfen bekleyin.`);
      }
      toSend = await compressPdf(file, {
        dpi: 150,
        quality: 0.75,
        skipBelowMB: 20,
        onProgress: (done, total) =>
          setPdfCompressInfo(`PDF küçültülüyor… sayfa ${done}/${total}`),
      });
      if (toSend !== file) {
        const newMb = (toSend.size / 1024 / 1024).toFixed(1);
        setPdfCompressInfo(`Küçültme tamam (${mb} MB → ${newMb} MB). Yükleniyor…`);
      } else {
        setPdfCompressInfo(null);
      }
    } catch (e) {
      console.error('PDF küçültme hatası, orijinal yükleniyor:', e);
      setPdfCompressInfo(null);
      toSend = file;
    }
    const body = new FormData();
    body.append('dataFile', toSend);
    return { url: 'https://buharaadmin.stechomeyazilim.info:8099/uploadfile', body };
  }

  // Kapak görseli yükleme durumu
  const handleChangeStatusImage = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNameImage(result.file.filename)
        }
      }
    }
  }

  // PDF yükleme durumu
  const handleChangeStatusPDF = ({ xhr }, status) => {
    if (status === 'done') setPdfCompressInfo(null);
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNamePDF(result.file.filename)
          setPdfCompressInfo(null)
        }
      }
    }
  }

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [orderList, setOrderList] = useState([]);
  const [order, setOrder] = useState(null);
  const [getEditCatalog, setEditCatalog] = useState(null);
  const [langModal, setLangModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      title: (getEditCatalog && getEditCatalog.Catalog_Title) || '',
      desc: (getEditCatalog && getEditCatalog.Catalog_Desc) || '',
      year: (getEditCatalog && getEditCatalog.Catalog_Year) || '',
      order: (getEditCatalog && getEditCatalog.Catalog_Order) || '',
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Başlığı Giriniz"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateCatalog = {
          ID: order ? order.ID : 0,
          Catalog_Title: values.title,
          Catalog_Desc: values.desc,
          Catalog_Image: getFileNameImage,
          Catalog_PDF: getFileNamePDF,
          Catalog_Year: values.year ? Number(values.year) : null,
          Catalog_Order: values.order ? Number(values.order) : 0,
          Catalog_IsActive: getIsActive,
        };
        dispatch(onUpdateCatalog(updateCatalog));
        validation.resetForm();
      } else {
        const newOrder = {
          Catalog_Title: values["title"],
          Catalog_Desc: values["desc"],
          Catalog_Image: getFileNameImage,
          Catalog_PDF: getFileNamePDF,
          Catalog_Year: values["year"] ? Number(values["year"]) : null,
          Catalog_Order: values["order"] ? Number(values["order"]) : 0,
          Catalog_IsActive: getIsActive,
          // Backend datetime alanı boş gelince SQL datetime aralık hatası veriyor;
          // geçerli bir tarih göndererek bunu önlüyoruz.
          Catalog_CreatedDateTime: new Date().toISOString(),
        };
        dispatch(onAddCatalog(newOrder));
        validation.resetForm();
      }
      toggle();
    },
  });

  const dispatch = useDispatch();
  const { orders } = useSelector(state => ({
    orders: state.contacts.catalog,
  }));

  useEffect(() => {
    if (orders && !orders.length) {
      dispatch(onGetCatalog());
    }
  }, [dispatch, orders]);

  useEffect(() => {
    setOrderList(orders);
  }, [orders]);

  useEffect(() => {
    if (!isEmpty(orders) && !!isEdit) {
      setOrderList(orders);
      setIsEdit(false);
    }
  }, [orders]);

  const toggle = () => {
    if (modal) {
      setModal(false);
      setOrder(null);
    } else {
      setModal(true);
    }
  };

  const handleOrderClick = arg => {
    const order = arg;
    setEditCatalog(order)
    setOrder(order);
    setIsEdit(true);

    setFileNameImage(order.Catalog_Image)
    setFileNamePDF(order.Catalog_PDF)
    setIsActive(order.Catalog_IsActive)
    toggle();
  };

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (order) => {
    setOrder(order);
    setDeleteModal(true);
  };

  const handleDeleteOrder = () => {
    if (order && order.ID) {
      dispatch(onDeleteCatalog(order.ID));
      setDeleteModal(false);
    }
  };

  const handleOrderClicks = () => {
    setOrderList("");
    setIsEdit(false);
    setEditCatalog(null);
    setFileNameImage(null);
    setFileNamePDF(null);
    setIsActive(false);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        Header: 'BAŞLIK',
        accessor: 'Catalog_Title',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          return <Name {...cellProps} />;
        }
      },
      {
        Header: "Kapak",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.Catalog_Image ? (
              <div className="avatar-xl">
                {cellProps.Catalog_Title != null ? <span className="avatar-title rounded-circle">
                  {cellProps.Catalog_Title.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <div>
                <img
                  className="avatar-xl"
                  src={IMG_BASE + cellProps.Catalog_Image}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },
      {
        Header: "PDF",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {cellProps.Catalog_PDF ? (
              <a
                href={IMG_BASE + cellProps.Catalog_PDF}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-outline-danger"
              >
                <i className="mdi mdi-file-pdf-box me-1" /> Görüntüle
              </a>
            ) : (
              <span className="text-muted">—</span>
            )}
          </>
        ),
      },
      {
        Header: 'Yıl',
        accessor: 'Catalog_Year',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          return <Name {...cellProps} />;
        }
      },
      {
        Header: 'Sıra',
        accessor: 'Catalog_Order',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          return <Name {...cellProps} />;
        }
      },
      {
        Header: 'Aktiflik Durumu',
        accessor: 'Catalog_IsActive',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          return <Status {...cellProps} />;
        }
      },
      {
        Header: 'İşlemler',
        accessor: 'action',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const orderData = cellProps.row.original;
                  handleOrderClick(orderData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-info"
                onClick={() => {
                  setSelectedItem(cellProps.row.original);
                  setLangModal(true);
                }}
              >
                <i className="mdi mdi-translate font-size-18" id="langtooltip-catalog" />
                <UncontrolledTooltip placement="top" target="langtooltip-catalog">
                  Çeviriler (5 Dil)
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const orderData = cellProps.row.original;
                  onClickDelete(orderData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        }
      },
    ],
    []
  );

  const Preview = ({ meta }) => {
    const { name, percent, status } = meta;
    return (
      <div className="preview-box">
        <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }

  return (
    <React.Fragment>
      <LangModal
        isOpen={langModal}
        toggle={() => setLangModal(false)}
        title="Katalog"
        tableName="Catalog_Lang"
        foreignKey="Catalog_ID"
        foreignKeyValue={selectedItem?.ID}
        fields={[
          { name: 'Catalog_Title', label: 'Başlık', type: 'text' },
          { name: 'Catalog_Desc', label: 'Açıklama', type: 'textarea' },
          { name: 'Catalog_Image', label: 'Kapak Görseli', type: 'image' },
          { name: 'Catalog_PDF', label: 'Katalog PDF', type: 'file' },
        ]}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kataloglar" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={orders}
                    isGlobalFilter={true}
                    isAddCatalog={true}
                    handleOrderClicks={handleOrderClicks}
                    customPageSize={10}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Katalog Düzenle" : "Katalog Ekle"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="mb-3">
                  <Label className="form-label">Başlık</Label>
                  <Input
                    name="title"
                    type="text"
                    placeholder="Başlık"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.title || ""}
                    invalid={
                      validation.touched.title && validation.errors.title ? true : false
                    }
                  />
                  {validation.touched.title && validation.errors.title ? (
                    <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label className="form-label">Açıklama</Label>
                  <Input
                    name="desc"
                    type="textarea"
                    rows="2"
                    placeholder="Açıklama"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.desc || ""}
                  />
                </div>

                <Row>
                  <Col xs={6}>
                    <div className="mb-3">
                      <Label className="form-label">Yıl</Label>
                      <Input
                        name="year"
                        type="number"
                        placeholder="2026"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.year || ""}
                      />
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className="mb-3">
                      <Label className="form-label">Sıra</Label>
                      <Input
                        name="order"
                        type="number"
                        placeholder="0"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.order || ""}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} className="mb-3">
                    <label htmlFor="cover">Kapak Görseli (3:4 önerilir)</label>
                    <Dropzone
                      getUploadParams={getUploadParams}
                      onChangeStatus={handleChangeStatusImage}
                      maxFiles={1}
                      styles={{
                        dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                        inputLabelWithFiles: { margin: '20px 3%' }
                      }}
                      canRemove={false}
                      PreviewComponent={Preview}
                      accept="image/*"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} className="mb-3">
                    <label htmlFor="pdf">Katalog PDF Dosyası</label>
                    <Dropzone
                      getUploadParams={getUploadParamsPDF}
                      onChangeStatus={handleChangeStatusPDF}
                      maxFiles={1}
                      styles={{
                        dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                        inputLabelWithFiles: { margin: '20px 3%' }
                      }}
                      canRemove={false}
                      PreviewComponent={Preview}
                      accept="application/pdf,.pdf"
                    />
                    {pdfCompressInfo && (
                      <div className="text-info mt-2" style={{ fontSize: 13 }}>
                        <i className="mdi mdi-information-outline me-1" />
                        {pdfCompressInfo}
                      </div>
                    )}
                    <small className="text-muted d-block mt-1">
                      Büyük PDF'ler yüklemeden önce tarayıcıda otomatik küçültülür (web için optimize).
                    </small>
                  </Col>
                </Row>

                <div className="d-flex">
                  {getFileNameImage != null ? <Row>
                    <label htmlFor="cover">Mevcut Kapak Görseli</label>
                    <Col xs={12} className="mb-3">
                      <img
                        className="avatar-xl"
                        src={IMG_BASE + getFileNameImage}
                        alt=""
                      />
                    </Col>
                  </Row> : null}

                  {getFileNamePDF != null ? <Row>
                    <label htmlFor="pdf">Mevcut PDF</label>
                    <Col xs={12} className="mb-3">
                      <a
                        href={IMG_BASE + getFileNamePDF}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-outline-danger"
                      >
                        <i className="mdi mdi-file-pdf-box me-1" /> {getFileNamePDF}
                      </a>
                    </Col>
                  </Row> : null}
                </div>

                <div className="square-switch mb-3">
                  <input
                    type="checkbox"
                    id="square-switch-catalog"
                    className="switch"
                    defaultChecked={getIsActive}
                    onChange={() => setIsActive(!getIsActive)}
                  />
                  <label
                    htmlFor="square-switch-catalog"
                    data-on-label="Aktif "
                    data-off-label="Pasif"
                  />
                </div>

                <Row>
                  <Col>
                    <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-success save-user"
                      >
                        Kaydet
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
}

CatalogPage.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default CatalogPage;
